module.exports = __webpack_public_path__ + "img/tuceng25.a013c63a.png";